// src/pages/Vouchers/SupplierPaymentForm.jsx
import React from 'react';
import VoucherForm, { VOUCHER_CONFIGS } from './VoucherForm';

export default function SupplierPaymentForm() {
  return <VoucherForm config={VOUCHER_CONFIGS.supplierPayment} />;
}
